import Model from '@/models/BaseModel'
import Reseller from '@/models/Reseller'

export default class ResellerType extends Model {
    static reseller = 'reseller'
    static whitelabel = 'whitelabel'
    static partner = 'partner'
    static businessConsultant = 'business_consultant'

    resourceName() {
        return 'reseller-types'
    }

    fields() {
        return [
            'id',
            'name',
            'referable',
            'active',
            'default_for_has_support',
            'contract_url',
            'billable',
        ]
    }

    computed() {
        return {
            id(type) {
                return parseInt(type.id)
            },
        }
    }

    relationships() {
        return {
            reseller: new Reseller(),
        }
    }

    get resellers() {
        return this._resellers
    }
}
